import {Button, Form, Image, Input, NavBar, Toast} from "antd-mobile";
import React from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {userOpayCreate} from "../../common/ApiAction";
import {TOASTDURATION} from "../../common/Utils";

const Repayment = () => {
    const navigate = useNavigate();
    const {state} = useLocation();
    const { t } = useTranslation();

    const back = () => {
        navigate(-1);
    };
    const onFinish = (values: any) => {
        Toast.show({icon: 'loading', content: 'Repayment...', duration: 0})
        userOpayCreate(state?.orderNo, values.amount).then((res: any) => {
            Toast.clear();
            if (!res.executed) {
                Toast.show({icon: 'fail', content: res.message, duration: TOASTDURATION})
            } else {
                window.open(res.data, '_blank', 'noopener,noreferrer');
            }
        }).catch((err) => {
            Toast.clear();
            Toast.show({icon: 'fail', content: err?.message || 'Repayment fail', duration: 1000})
        })
    }

    return <div style={{display: "flex", flexDirection: "column", width: '100%', backgroundColor: '#F5F6FA'}}>
        <NavBar onBack={back} style={{backgroundColor: '#FFF'}}>RepayMent</NavBar>
        <div style={{backgroundColor: '#FFF', marginTop: 10}}>
            <div style={{display: "flex", flexDirection: "column", alignItems: "center", marginBottom: 25}}>
                <Image src={require('../../assets/icon_ego_logo.jpg')} style={{width: 300, height: 150}}/>
                <span style={{fontSize: 16, fontWeight: 'bold'}}>OrderNo: {state?.orderNo}</span>
            </div>
            <Form
                onFinish={onFinish}
                mode={'card'}
                layout='horizontal'
                footer={<Button shape='rounded' block type='submit' color='primary' size='middle'>{t('user_repayment_title')}</Button>}>
                <Form.Header>{t('user_repayment_title')}</Form.Header>
                <Form.Item style={{border: 'solid 1px #E5E5E5', borderRadius: 10}} name='amount' rules={[{ required: true, message: t('user_repayment_placeholder') }]}>
                    <Input type={"number"} placeholder={t('user_repayment_placeholder')} />
                </Form.Item>
            </Form>
        </div>
    </div>
}
export default Repayment
